export default "__VITE_ASSET__C46i7WAN__"